import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiImage, FiBarChart2, FiUsers, FiUserCheck } from 'react-icons/fi';

const AdminDashboard = () => {
  const adminLinks = [
    {
      path: '/admin/characters',
      title: 'Character Management',
      description: 'Create and manage predefined characters',
      icon: FiUserCheck,
      color: 'bg-cyan-500'
    },
    {
      path: '/admin/mail',
      title: 'Email Management',
      description: 'Send bulk emails and manage campaigns',
      icon: FiMail,
      color: 'bg-blue-500'
    },
    {
      path: '/admin/users',
      title: 'User Management',
      description: 'View and manage user accounts',
      icon: FiUsers,
      color: 'bg-indigo-500'
    },
    {
      path: '/admin/upload',
      title: 'Image Upload',
      description: 'Upload and manage images',
      icon: FiImage,
      color: 'bg-green-500'
    },
    {
      path: '/admin/analytics',
      title: 'Analytics',
      description: 'View visit analytics and user activity',
      icon: FiBarChart2,
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Admin Dashboard</h1>
        <p className="text-gray-600 mb-8">Manage your application</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {adminLinks.map((link) => {
            const Icon = link.icon;
            return (
              <Link
                key={link.path}
                to={link.path}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 overflow-hidden"
              >
                <div className={`${link.color} h-32 flex items-center justify-center`}>
                  <Icon className="text-white text-6xl" />
                </div>
                <div className="p-6">
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    {link.title}
                  </h2>
                  <p className="text-gray-600 text-sm">
                    {link.description}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
